// GET events in progress v1Kpi
export const GET_EVENTS = 'app/store/v1Kpi/GET_EVENTS';
export const GET_EVENTS_SUCCESS = 'app/store/v1Kpi/GET_EVENTS_SUCCESS';
export const GET_EVENTS_ERROR = 'app/store/v1Kpi/GET_EVENTS_ERROR';

// GET contacts on Seekube
export const GET_CONTACTS = 'app/store/v1Kpi/GET_CONTACTS';
export const GET_CONTACTS_SUCCESS = 'app/store/v1Kpi/GET_CONTACTS_SUCCESS';
export const GET_CONTACTS_ERROR = 'app/store/v1Kpi/GET_CONTACTS_ERROR';
